// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__Tsyq5","effect":"styles_effect__F2OLi"};